<div class="historial">
  <div class="historial__header">
    <div>
      <h2 class="historial__title">Historial de estados</h2>
      <p class="historial__subtitle">
        Consulta los cambios realizados en este registro<span *ngIf="data.personalName"> · {{ data.personalName }}</span>
      </p>
    </div>
    <button type="button" class="historial__close" aria-label="Cerrar" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="historial__body">
    <div class="historial__loading" *ngIf="loading">
      <mat-spinner diameter="32"></mat-spinner>
    </div>

    <ng-container *ngIf="!loading">
      <div class="historial__notice" *ngIf="historyUnavailable">
        <mat-icon>info</mat-icon>
        <span>No fue posible cargar el historial completo. Se muestra el estado actual.</span>
      </div>

      <!-- Estado vacío cuando no hay movimientos en el historial -->
      <div class="historial__empty" *ngIf="movements.length === 0">
        <mat-icon>history_toggle_off</mat-icon>
        <h4>Sin historial de revisión</h4>
        <p>Este registro no cuenta con movimientos de revisión registrados.</p>
      </div>

      <ul class="timeline" *ngIf="movements.length > 0">
        <li class="timeline__item" *ngFor="let mov of movements; let first = first; let last = last"
            [class.timeline__item--last]="last">
          <span class="timeline__dot" [ngClass]="mov.cssClass"></span>
          <div class="timeline__content">
            <div class="timeline__head">
              <span class="timeline__label" [ngClass]="mov.cssClass">{{ mov.label }}</span>
              <span class="timeline__current" *ngIf="first">Estado actual</span>
            </div>
            <div class="timeline__meta" *ngIf="mov.date || mov.userName">
              <span class="timeline__meta-item" *ngIf="mov.date">
                <mat-icon>calendar_today</mat-icon>{{ mov.date }}
              </span>
              <span class="timeline__meta-item" *ngIf="mov.userName">
                <mat-icon>person_outline</mat-icon>Responsable:&nbsp;<strong>{{ mov.userName }}</strong>
              </span>
            </div>
            <div class="timeline__obs" *ngIf="mov.comment">
              <strong>Observación:</strong>
              <span>{{ mov.comment }}</span>
            </div>
          </div>
        </li>
      </ul>
    </ng-container>
  </div>

  <div class="historial__footer">
    <span class="historial__count" *ngIf="!loading">
      {{ movements.length }} {{ movements.length === 1 ? 'movimiento' : 'movimientos' }}
    </span>
    <button type="button" class="historial__btn" (click)="close()">Cerrar</button>
  </div>
</div>
